<template>
  <div class="block_container">
    <div v-for="(wel,index) in welfare" :key="index">
      <div class="block_card">
        <h3 class="van-ellipsis">{{wel.type}}</h3>
        <br />
        <van-cell title="标准/人" :value="wel.standard" :border="false" style="text-align:left;padding: 10px 5px;" />
        <van-cell title="慰问对象" :value="wel.target" :border="false" style="text-align:left;padding: 10px 5px;" />
        <van-cell title="慰问形式" :value="wel.methods" :border="false" style="text-align:left;padding: 10px 5px;" />
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar, Cell, Tabbar, TabbarItem } from 'vant';

export default {
  name: 'Holiday',
  data () {
    return {
      welfare: [
        {
          type: "三八妇女节慰问",
          standard: "300/人",
          target: "所有180regular女员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "劳动节慰问",
          standard: "400/人",
          target: "所有180regular员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "端午节慰问",
          standard: "400/人",
          target: "所有180regular员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "中秋节慰问",
          standard: "400/人",
          target: "所有180regular员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "国庆节慰问",
          standard: "400/人",
          target: "所有180regular员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "元旦慰问",
          standard: "400/人",
          target: "所有180regular员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "新春慰问",
          standard: "400/人",
          target: "所有180regular员工",
          methods: "实物或者消费卡类",
        },
        {
          type: "生日慰问",
          standard: "300/人",
          target: "所有180regular员工",
          methods: "蛋糕卡,每月发放",
        },
        {
          type: "夏日高温慰问",
          standard: "200/人",
          target: "所有180regular员工",
          methods: "冷饮,饮料,7-8月发放",
        }
      ]
    };
  },
  mounted() {
    setInterval(this.updateSteps, 1500);
  },
  methods: {
    updateSteps() {
      if (this.activeStep >= 4) {
        this.activeStep = 0;
      } else {
        this.activeStep += 1;
      }
    }
  }
}
</script>
<style scoped>
.block_container {
    background-color: #f7f8fa;
    font-size: 14px;
    line-height: 26px;
}
.block_card {
    margin-bottom: 24px;
    padding: 24px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 12px #ebedf0;
}
h3 {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 18px;
    margin: 0;
    text-align:left;
}
</style>


// WEBPACK FOOTER //
// src/components/Holiday.vue